import * as styles from "./ColorPickerTrigger.css";

import { clsx } from "clsx";
import type { JSX, KeyboardEvent, PointerEvent } from "react";

import { Popover as BasePopover } from "@base-ui/react/popover";
import type { BaseUIEvent } from "@base-ui/react/types";
import { pointerOffsetIn } from "@frontend/utils/pointerAlign";

import { useColorPickerContext } from "./ColorPicker.context";
import type { ColorPickerTriggerProps } from "./ColorPicker.types";

export function ColorPickerTrigger({
  className,
  children,
  layout,
  onPointerDown,
  onKeyDown,
  ...props
}: ColorPickerTriggerProps): JSX.Element {
  const { size, disabled, pointerOffsetRef } = useColorPickerContext();

  function handlePointerDown(
    event: BaseUIEvent<PointerEvent<HTMLButtonElement>>,
  ) {
    pointerOffsetRef.current = pointerOffsetIn(
      event.currentTarget,
      event.clientX,
    );

    onPointerDown?.(event);
  }

  function handleKeyDown(event: BaseUIEvent<KeyboardEvent<HTMLButtonElement>>) {
    if (event.key === "Enter" || event.key === " ") {
      pointerOffsetRef.current = 0;
    }

    onKeyDown?.(event);
  }

  return (
    <BasePopover.Trigger
      data-slot="color-picker-trigger"
      disabled={disabled}
      className={clsx(styles.trigger({ size, layout }), className)}
      onPointerDown={handlePointerDown}
      onKeyDown={handleKeyDown}
      {...props}
    >
      {children}
    </BasePopover.Trigger>
  );
}
